<template>
	<div>
		<CLoader :pConfigLoad="ConfigLoad">
			<template slot="BodyFormLoad">
				<div class="row">
					<div class="col-lg-9">
						<div class="row">
							<div class="col-lg-4">
                    		    <label >Código Empresa </label>
                    		    <input type="text" v-model="ProyectoMaterial.CodigoEmpresa" class="form-control" placeholder="Código Empresa" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.CodigoEmpresa" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-4">
                    		    <label >Código Fabricante </label>
                    		    <input type="text" v-model="ProyectoMaterial.CodigoFabricante" class="form-control" placeholder="SKU" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.CodigoFabricante" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-4">
                    		    <label >Ítem </label>
                    		    <input type="text" v-model="ProyectoMaterial.Item" class="form-control" placeholder="Item" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Item" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
						</div>
						<div class="row">
							<div class="col-lg-3">
                    		    <label >Unidad </label>
                    		    <input type="text" v-model="ProyectoMaterial.Unidad" class="form-control" placeholder="Unidad" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Unidad" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-3">
								<label>Marca</label>
								<input type="text" class="form-control" v-model="ProyectoMaterial.Marca" placeholder="Marca">
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Marca" :Mensaje="this.errorvalidacion.Marca[0]"></Cvalidation></label>
							</div>
							<div class="col-lg-3">
								<label>Modelo</label>
								<input type="text" class="form-control" v-model="ProyectoMaterial.Modelo" placeholder="Modelo">
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Modelo" :Mensaje="this.errorvalidacion.Modelo[0]"></Cvalidation></label>
							</div>
							<div class="col-lg-3">
								<label>Factura</label>
								<input type="text" class="form-control" v-model="ProyectoMaterial.Factura" placeholder="Factura">
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Factura" :Mensaje="this.errorvalidacion.Factura[0]"></Cvalidation></label>
							</div>
						</div>
						<div class="row">
							<div class="col-lg-2">
                    		    <label >Presupuesto</label>
                    		    <vue-numeric placeholder="$ 0.00"  :minus="false"  class="form-control "  currency="$" separator="," :precision="2" v-model="ProyectoMaterial.Presupuesto"></vue-numeric>
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Presupuesto" :Mensaje="this.errorvalidacion.Presupuesto[1]"></Cvalidation></label>
                    		</div>
							<div class="col-lg-2">
                    		    <label >Comprometido</label>
                    		    <vue-numeric placeholder="$ 0.00"  :minus="false"  class="form-control "  currency="$" separator="," :precision="2" v-model="ProyectoMaterial.Comprometido"></vue-numeric>
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Comprometido" :Mensaje="this.errorvalidacion.Comprometido[1]"></Cvalidation></label>
                    		</div>
							<div class="col-lg-2">
                    		    <label >Adquirido</label>
                    		    <vue-numeric placeholder="$ 0.00"  :minus="false"  class="form-control "  currency="$" separator="," :precision="2" v-model="ProyectoMaterial.Adquirido"></vue-numeric>
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Adquirido" :Mensaje="this.errorvalidacion.Adquirido[1]"></Cvalidation></label>
                    		</div>
							<div class="col-lg-2">
								<label for="">Requerido</label>
								<v-date-picker v-model="ProyectoMaterial.Requerido" :mode="typeCalendar"
									:popover="{
										placement: 'bottom',
										visibility: 'click'
									}"
									:input-props="{
										class: 'form-control cal-black',
										style: 'cursor:pointer;'
									}"
                				    :locale="'es-MX'"
								/>
							</div>
							<div class="col-lg-2">
								<label for="">Compra</label>
								<v-date-picker v-model="ProyectoMaterial.Compra" :mode="typeCalendar"
									:popover="{
										placement: 'bottom',
										visibility: 'click'
									}"
									:input-props="{
										class: 'form-control cal-black',
										style: 'cursor:pointer;'
									}"
                				    :locale="'es-MX'"
								/>
							</div>
							<div class="col-lg-2">
								<label for="">Cantidad</label>
								<input type="text" class="form-control" v-model="ProyectoMaterial.Cantidad">
							</div>
						</div>
						<div class="row">
							<div class="col-lg-3">
								<label for="">Estatus</label>
								<select v-model="ProyectoMaterial.Estatus" class="form-control">
									<option value="">-Estatus-</option>
									<option value="1">Comprado</option>
									<option value="2">Proceso Compra</option>
									<option value="3">Pendiente</option>
									<option value="4">No Disponible</option>
									<option value="5">Cancelado</option>
								</select>
							</div>
						</div>
					</div>
					<div class="col-lg-3">
						<div class="row">
							<div class="col-lg-12">
								<div class="avatar-upload almacen-upload">
									<div class="avatar-edit">
										<input
											id="filematerial"
											ref="imagenmaterial"
											type="file"
											name="myfile"
											@change="uploadImage()"
											accept=".png, .jpg, .jpeg"
										/>
										<label for="filematerial"></label>
									</div>
									<div class="avatar-preview imagenes-almacen">
										<div
											id="imagePreviewMaterial"
											style="background-image: url(Img);"
										></div>
									</div>
								</div>
								<label class="ml-5 pl-3 mt-2">Recomendada 400 x 400</label>
							</div>
						</div>
					</div>
				</div>
				<div class="row mt-3">
					<div class="col-lg-12">
						<label for="">Descripción</label>
						<textarea v-model="ProyectoMaterial.Descripcion" maxlength="70" cols="30" rows="1" class="form-control" placeholder="Descripción"></textarea>
					</div>
				</div>
			</template>
		</CLoader>
	</div>
</template>

<script>
import Cbtnsave from '@/components/Cbtnsave.vue'
import Clist from '@/components/Clist.vue';
import Cvalidation from '@/components/Cvalidation.vue'
import ListForm from '@/components/Clistform.vue';
import Cbtnaccion from "@/components/Cbtnaccion.vue";
import Modal from '@/components/Cmodal.vue';
import $$ from "jquery";

export default {
	name:'Form',
	props:['NameList','poBtnSave'],
	components:{Cbtnsave,Clist,Cvalidation,Modal,ListForm,Cbtnaccion},
	data() {
		return {
			Modal:true,
			FormName:'MaterialForm',//Sirve para donde va regresar
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
			ProyectoMaterial:{
				IdProyectoMaterial:0,
				IdProyecto:0,
				IdMaterial:0,
				CodigoEmpresa:'',
				CodigoFabricante:'',
				Item:'',
				Unidad:'',
				Marca:'',
				Modelo:'',
				Cantidad:'',
				Factura:'',
				Presupuesto:'',
				Comprometido:'',
				Adquirido:'',
				Requerido:'',
				Compra:'',
				Estatus:'',
				Descripcion:'',
				Imagen:''
			},
			Imagen:"",
			errorvalidacion:[],
			EmitSeccion:this.poBtnSave.EmitSeccion
		}
	},
	methods: {
		async Guardar(){
			let FechaRequerido='';
			let FechaCompra='';
			if (this.ProyectoMaterial.Requerido!='' && this.ProyectoMaterial.Requerido!=undefined) {
                let day=this.ProyectoMaterial.Requerido.getDate();
                let month=this.ProyectoMaterial.Requerido.getMonth()+1;
                let year=this.ProyectoMaterial.Requerido.getFullYear();
                FechaRequerido=year+'-'+month+'-'+day;   
            }
			if (this.ProyectoMaterial.Compra!='' && this.ProyectoMaterial.Compra!=undefined) {
                let day=this.ProyectoMaterial.Compra.getDate();
                let month=this.ProyectoMaterial.Compra.getMonth()+1;
                let year=this.ProyectoMaterial.Compra.getFullYear();
                FechaCompra=year+'-'+month+'-'+day;   
            }
			this.poBtnSave.toast=0; 
            this.poBtnSave.disableBtn=true;
			let formData=new FormData();
			formData.set('IdProyectoMaterial',this.ProyectoMaterial.IdProyectoMaterial);
			formData.set('IdProyecto',this.ProyectoMaterial.IdProyecto);
			formData.set('IdMaterial',this.ProyectoMaterial.IdMaterial);
			formData.set('CodigoEmpresa',this.ProyectoMaterial.CodigoEmpresa);
			formData.set('CodigoFabricante',this.ProyectoMaterial.CodigoFabricante);
			formData.set('Item',this.ProyectoMaterial.Item);
			formData.set('Unidad',this.ProyectoMaterial.Unidad);
			formData.set('Marca',this.ProyectoMaterial.Marca);
			formData.set('Modelo',this.ProyectoMaterial.Modelo);
			formData.set('Factura',this.ProyectoMaterial.Factura);
			formData.set('Cantidad',this.ProyectoMaterial.Cantidad);
			formData.set('Presupuesto',this.ProyectoMaterial.Presupuesto);
			formData.set('Comprometido',this.ProyectoMaterial.Comprometido);
			formData.set('Adquirido',this.ProyectoMaterial.Adquirido);
			formData.set('Requerido',FechaRequerido);
			formData.set('Compra',FechaCompra);
			formData.set('Estatus',this.ProyectoMaterial.Estatus);
			formData.set('Descripcion',this.ProyectoMaterial.Descripcion);
			formData.set('Imagen',this.ProyectoMaterial.Imagen);
			let file = this.$refs.imagenmaterial.files[0];
			formData.append("ImagenFile", file);
			await this.$http.post('proyectomaterial/modify',formData,{
				headers: {
                    'Content-Type': 'multipart/form-data'
                }
			}).then((res)=>{
				this.poBtnSave.disableBtn=false;  
                this.poBtnSave.toast=1;
                $('#'+this.EmitSeccion).modal('hide');
				this.bus.$emit('ListaPrincipal');
			}).catch((err)=>{
				this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
			});
		},
		Limpiar(){
			this.ProyectoMaterial={
				IdProyectoMaterial:0,
				IdProyecto:0,
				IdMaterial:0,
				CodigoEmpresa:'',
				CodigoFabricante:'',
				Item:'',
				Unidad:'',
				Marca:'',
				Modelo:'',
				Factura:'',
				Cantidad:'',
				Presupuesto:'',
				Comprometido:'',
				Adquirido:'',
				Requerido:new Date(),
				Compra:new Date(),
				Estatus:'',
				Descripcion:'',
				Imagen:''
			};
			this.errorvalidacion=[];
			this.Imagen="";
			const input = this.$refs.imagenmaterial;
			input.type = 'text'
            input.type = 'file';
			this.readURL(this.Imagen);
		},
		get_one(){
			this.ConfigLoad.ShowLoader=true;
			this.$http.get('proyectomaterial/recovery',{
				params:{IdProyectoMaterial: this.ProyectoMaterial.IdProyectoMaterial}
			}).then((res)=>{
				this.ProyectoMaterial=res.data.data.proyectomaterial;
				let Foto=res.data.data.proyectomaterial.Imagen;
				if (Foto != "" && Foto != null) {
					this.Imagen = res.data.data.ruta + this.ProyectoMaterial.Imagen;
				}
				this.readURL(this.Imagen);
				if (res.data.data.proyectomaterial.Requerido!=null){
					let formatedDate = res.data.data.proyectomaterial.Requerido.replace(/-/g, "\/");
					this.ProyectoMaterial.Requerido=new Date(formatedDate);
				}
				if (res.data.data.proyectomaterial.Compra!=null){
					let formatedDate2 = res.data.data.proyectomaterial.Compra.replace(/-/g, "\/");
					this.ProyectoMaterial.Compra=new Date(formatedDate2);
				}
			}).finally(()=>{
				this.ConfigLoad.ShowLoader=false;
			})
		},
		uploadImage() {
			this.ProyectoMaterial.Imagen = this.$refs.imagenmaterial.files[0];
			const image = this.$refs.imagenmaterial.files[0];
			const reader = new FileReader();
			var img = "";
			reader.readAsDataURL(image);

			reader.onload = e => {
				this.Imagen = e.target.result;
				this.readURL(this.Imagen);
			};
		},
		readURL(input) {
			$$("#imagePreviewMaterial").css("background-image", "url(" + this.Imagen + ")");
			$$("#imagePreviewMaterial").hide();
			$$("#imagePreviewMaterial").fadeIn(650);
		},
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
		this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdProyecto)=>{
            this.poBtnSave.disableBtn=false;
			// console.log(this.pListProyectoReporteObra);
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdProyecto!==undefined) {
                this.ProyectoMaterial.IdProyecto=IdProyecto;
            }
            if (Id > 0) {
				this.ProyectoMaterial.IdProyectoMaterial = Id;
				this.get_one();
			}
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        },
    }
}
</script>

<style>

</style>
